import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { CopyDetailsText as StyledCopyDetailsText } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/CopyDetailsText.tsx';
import styled from 'styled-components';
import { Text, TextProps } from '@mantine/core';
import React, { type ComponentProps } from 'react';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainText = asPlainComponent<ComponentProps<typeof Text>>(Text);

export const SecurityDetail = ({
	value = LONG_DASH,
	dataTestId,
	$shouldCapitalize = false,
}: {
	value?: string | number;
	dataTestId?: string;
	$shouldCapitalize?: boolean;
}) => (
	<StyledCopyDetailsText text={value}>
		<DetailValue data-testid={dataTestId} $shouldCapitalize={$shouldCapitalize}>
			{value}
		</DetailValue>
	</StyledCopyDetailsText>
);

export const DetailValue = styled(PlainText)<TextProps & { $shouldCapitalize?: boolean }>`
	font-size: 18px;
	line-height: 24px;
	font-weight: 400;
	color: ${({ theme }) => theme.v3.colors.dark[8]};
	text-transform: ${({ $shouldCapitalize }) => ($shouldCapitalize ? 'capitalize' : 'none')};
`;
